import axios from 'axios';

export default {
  site_settings: async (centro_id) => {
    const url = `${centro_id}/ai/site_settings`;
    const response = await axios.get(url);
    return response.data;
  },

  update_site_settings: async (centro_id, data) => {
    if (data.model === undefined) {
      throw "Missing parameter model for AI.update_site_settings";
    }
    const url = `${centro_id}/ai/update_site_settings/`;
    const response = await axios.put(url, data);
    return response.data;
  },

  action_suggestion: async (centro_id, action_id, qunit_id) => {
    const url = `${centro_id}/ai/action_suggestion/`;

    try {
      const response = await axios.get(url, {
        params: {
          qunit: qunit_id,
          action: action_id,
        },
      });
      return response.data;

    } catch (error) {
      const detail = (
        error
          && error.response
          && error.response.data
          && error.response.data.detail
      );

      if (detail) {
        throw new Error(detail);
      }

      throw error;
    }
  },
};
